var agp = agp || {};

agp.browser = (function () {

	function init() {

		$("html").removeClass("no-js").addClass("js");

		if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
			if (navigator.userAgent.indexOf('MSIE 9.') !== -1) {
				//agp.Debug.log("IE9");
				$("html").addClass("ie-9");
			}
		}
	}

	return {
		init: init
	};

}());